document.addEventListener("DOMContentLoaded", function () {
  const menuToggle = document.querySelector(".menu-toggle");
  const body = document.body;

  const ACTIVE_CLASS = "active";
  const MENU_ACTIVE_CLASS = "mobile-menu-active";

  menuToggle.addEventListener("click", function () {
    if (body.classList.contains(MENU_ACTIVE_CLASS)) {
      body.classList.remove(MENU_ACTIVE_CLASS);
      this.classList.remove(ACTIVE_CLASS);
    } else {
      body.classList.add(MENU_ACTIVE_CLASS);
      this.classList.add(ACTIVE_CLASS);
    }
  });

  const overlay = document.querySelector(".site-header__overlay");

  overlay.addEventListener("click", function () {
    if (body.classList.contains(MENU_ACTIVE_CLASS)) {
      body.classList.remove(MENU_ACTIVE_CLASS);
      menuToggle.classList.remove(ACTIVE_CLASS);
    }
  });
});
